import { render } from "./indexninebanner.vue?vue&type=template&id=99b2cb3a"
import script from "./indexninebanner.vue?vue&type=script&lang=js"
export * from "./indexninebanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__